export default "__VITE_ASSET__pVkC5Hlp__"